import { baseSmsMessageModel } from './sms_message';

const SmsCampaignOutreach = baseSmsMessageModel('SmsCampaignOutreach', { campaignId: String });

export default SmsCampaignOutreach;
